module.exports = __webpack_public_path__ + "static/media/Contact.bcfcb319.png";